module.exports = __webpack_public_path__ + "static/media/06_CORTININHA_SEM_BOJO_LISO_05.be6796f5.jpg";